export const PRODUCT_MAPPING_STORE_PATH = 'lines/productmapping/'
